/* tslint:disable */
/* eslint-disable */
export enum Currency {
  Unknown = 'UNKNOWN',
  Mxn = 'MXN',
  Usd = 'USD'
}
